module.exports = __webpack_public_path__ + "static/media/tc.1141220b.svg";